import React, { Component } from "react";
import { ProductConsumer } from "../../Context/AddProWakel";
import styled from "styled-components";

const FIELD_LABELS = {
    // Product / ProductTable
    name: "ناو",
    code: "کۆد",
    barcode: "باڕکۆد",
    numberOfDana: " دانە",
    numberOfDarzan: " دەرزان",
    raspinaKarton: "رەسید کارتۆن",
    price: "نرخ",
    npishtR: "نپشتڕ",
    npishtRID: "نپشتڕ IQD",
    raspinaKartonSell: "نرخی فرۆشتنی کارتۆن",
    raspinaKartonSellID: "نرخی فرۆشتنی کارتۆن IQD",
    npishtRSell: "نرخی فرۆشتن",
    npishtRSellID: "نرخی فرۆشتن IQD",
    productCode: "کۆدی ",
    number: "ژمارە",
    height: "بەرزی",
    width: "پانی",
    length: "درێژی",
    weight: "کێش",
    detail: "وردەکاری",
    rezha: "رێژە",
    font: "فۆنت",
    display: "پیشاندان",
    dp: "دەرزەن-پاکەت",
    nrxID: "نرخ IQD",
    kartonPrice: "نرخی کارتۆن",
    priceOneRRR: "نرخی تاک",
    // Sale / Buy
    zh_wasl: "ژ.وەسڵ",
    napishtry: "ناپشتری",
    nawpishtry: "ناوپشتری",
    pishtry: "پشتری",
    jopishtry: "جۆری پشتری",
    napishtryName: "ناوی وەکیل",
    jopishtryName: "ناوی جۆر",
    zh_bpishtry: "ژ.بپشتری",
    saleTable: "تێبلی فرۆشتن",
    BuyTable: "تێبلی کڕین",
    table: "تێبل",
    total: "کۆی گشتی",
    totalID: "کۆی گشتی IQD",
    totalDollar: "کۆی گشتی دۆلار",
    dashkan: "داشکان",
    dashkanID: "داشکان IQD",
    pepishtry: "پێپشتری",
    pishtryDashkan: "پشتری داشکان",
    nawpishtryNote: "تێبینی",
    ppishtry: "پپشتری",
    typePay: "شێوازی پارەدان",
    navpishtry: "ناڤ پشتری",
    wasl: "وەسڵ",
    rasid_dpishtry: "ڕەسیدی دپشتری",
    rasid_kkpishtry: "ڕەسیدی ککپشتری",
    qpishtry: "قپشتری",
    jpishtry: "جپشتری",
    // Wakil
    Name: "ناو",
    Phone: "مۆبایل",
    City: "شار",
    note: "تێبینی",
    qpishtryType: "جۆری قپشتری",
    // Para / Pardan / Mandwb  
    nawpishtryID: "ناوی ID",
    koypara: "کۆی پارە",
    joripara: "جۆری پارە",
    shwen: "شوێن",
    parpishtry: "پار",
    navdolar: "نرخی دۆلار",
    // Masrwfat
    papishtry: "پاپشتری",
    // Garanawa
    zh_pishtry: "ژ.پشتری",
    naw: "ناو",
    bripishtry: "بری پشتری",
    // User
    username: "ناوی بەکارهێنەر",
    role: "ئۆتۆرایزەشن",
    // Common
    createdAt: "بەرواری دروستکردن",
    updatedAt: "بەرواری گۆڕانکاری",
    _id: "ئایدی",
    __v: "ڤێرژن",
    // Additional fields
    karton: "کارتۆن",
    dana: "دانە",
    darzan: "دەرزان",
    nrx: "نرخ",
    nrxID_field: "نرخ IQD",
    koy: "کۆ",
    koyID: "کۆ IQD",
    npishtrykarton: "نپشتری کارتۆن",
    npishtryDana: "نپشتری دانە",
};

const MODEL_DISPLAY_NAMES = {
    Product: "کاڵا",
    ProductTable: "تێبلی کاڵا",
    Sale: "فرۆشتن",
    Buy: "کڕین",
    Broken: "شکان",
    Wakil: "وەکیل",
    Para: "پارە",
    Pardan: "پارەدان",
    Mandwb: "مەندوب",
    Garanawa: "گەڕانەوە",
    Masrwfat: "مەسروفات",
    Apeopple: "کەس",
    Paradarhenan: "پارەدەرهێنان",
    Parawargrtn: "پارەوەرگرتن",
    Paraybardast: "پارەی بەردەست",
    ParaGorinawa: "پارە گۆڕینەوە",
    User: "بەکارهێنەر",
    Rent: "کرێ",
    TesxtOnBord: "قەرزی دەفتەر",
    Setting: "ڕێکخستن",
    PriceUpdate: "نوێکردنەوەی نرخ",
};

const SUB_TABLE_KEYS = ["saleTable", "BuyTable", "table"];

class ModelAuditLog extends Component {
    getLabel = (key) => {
        return FIELD_LABELS[key] || key;
    };

    getModelLabel = (model) => {
        return MODEL_DISPLAY_NAMES[model] || model;
    };

    formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
    };

    handlePrint = (log) => {
        if (!log) return;
        const printWindow = window.open("", "_blank", "width=900,height=700");
        const oldData = log.oldData || {};
        const newData = log.newData || {};
        const allKeys = [
            ...new Set([...Object.keys(oldData), ...Object.keys(newData)]),
        ].filter((k) => !SUB_TABLE_KEYS.includes(k));

        let rowsHtml = allKeys
            .map((key) => {
                const oldVal =
                    oldData[key] !== undefined && oldData[key] !== null
                        ? String(oldData[key])
                        : "-";
                const newVal =
                    newData[key] !== undefined && newData[key] !== null
                        ? String(newData[key])
                        : "-";
                const changed = oldVal !== newVal;
                return `<tr>
        <td style="padding:6px 12px;border:1px solid #ccc;text-align:right;${changed
                        ? "background:#fff3cd;text-decoration:line-through;color:red;"
                        : ""
                    }">${oldVal}</td>
        <td style="padding:6px 12px;border:1px solid #ccc;text-align:right;${changed ? "background:#d4edda;color:green;" : ""
                    }">${newVal}</td>
        <td style="padding:6px 12px;border:1px solid #ccc;text-align:right;font-weight:bold;">${this.getLabel(
                        key
                    )}</td>
      </tr>`;
            })
            .join("");

        // Sub-table diffs
        let subTablesHtml = "";
        SUB_TABLE_KEYS.forEach((stk) => {
            const oldArr = oldData[stk];
            const newArr = newData[stk];
            if (!oldArr && !newArr) return;
            const oldItems = Array.isArray(oldArr) ? oldArr : [];
            const newItems = Array.isArray(newArr) ? newArr : [];
            const maxLen = Math.max(oldItems.length, newItems.length);
            if (maxLen === 0) return;

            const allSubKeys = new Set();
            oldItems.forEach((item) => Object.keys(item).forEach((k) => allSubKeys.add(k)));
            newItems.forEach((item) => Object.keys(item).forEach((k) => allSubKeys.add(k)));
            const subKeys = [...allSubKeys].filter((k) => k !== "_id" && k !== "__v");

            let subRows = "";
            for (let i = 0; i < maxLen; i++) {
                const oldItem = oldItems[i] || {};
                const newItem = newItems[i] || {};
                subRows += `<tr style="background:#f8f9fa;"><td colspan="${subKeys.length
                    }" style="padding:4px 8px;border:1px solid #ccc;text-align:right;font-weight:bold;">ڕیز ${i + 1
                    } - کۆن</td></tr>`;
                subRows += `<tr>${subKeys
                    .map((k) => {
                        const ov = oldItem[k] !== undefined ? String(oldItem[k]) : "-";
                        const nv = newItem[k] !== undefined ? String(newItem[k]) : "-";
                        const ch = ov !== nv;
                        return `<td style="padding:4px 8px;border:1px solid #ccc;text-align:right;${ch
                                ? "background:#fff3cd;text-decoration:line-through;color:red;"
                                : ""
                            }">${ov}</td>`;
                    })
                    .join("")}</tr>`;
                subRows += `<tr style="background:#f0fff0;"><td colspan="${subKeys.length}" style="padding:4px 8px;border:1px solid #ccc;text-align:right;font-weight:bold;">ڕیز ${i + 1
                    } - نوێ</td></tr>`;
                subRows += `<tr>${subKeys
                    .map((k) => {
                        const ov = oldItem[k] !== undefined ? String(oldItem[k]) : "-";
                        const nv = newItem[k] !== undefined ? String(newItem[k]) : "-";
                        const ch = ov !== nv;
                        return `<td style="padding:4px 8px;border:1px solid #ccc;text-align:right;${ch ? "background:#d4edda;color:green;" : ""
                            }">${nv}</td>`;
                    })
                    .join("")}</tr>`;
            }

            subTablesHtml += `
        <h3 style="margin-top:20px;text-align:right;">${this.getLabel(stk)}</h3>
        <table style="width:100%;border-collapse:collapse;margin-bottom:10px;">
          <thead><tr>${subKeys
                    .map(
                        (k) =>
                            `<th style="padding:4px 8px;border:1px solid #ccc;text-align:right;background:#343a40;color:#ffc107;">${this.getLabel(
                                k
                            )}</th>`
                    )
                    .join("")}</tr></thead>
          <tbody>${subRows}</tbody>
        </table>`;
        });

        const html = `<!DOCTYPE html>
<html dir="rtl" lang="ku">
<head>
  <meta charset="UTF-8">
  <title>ژوورنالی تبدیلات - ${this.getModelLabel(log.modelName)}</title>
  <style>
    @page { size: A4; margin: 15mm; }
    body { font-family: 'Segoe UI', Tahoma, sans-serif; direction: rtl; padding: 20px; }
    h2 { text-align: center; margin-bottom: 10px; }
    .info { margin-bottom: 15px; text-align: right; }
    .info span { margin-left: 20px; }
    table { width: 100%; border-collapse: collapse; margin-bottom: 15px; }
    th { background: #343a40; color: #ffc107; padding: 8px 12px; border: 1px solid #ccc; text-align: right; }
  </style>
</head>
<body>
  <h2>ژوورنالی تبدیلات</h2>
  <div class="info">
    <span><b>بەش:</b> ${this.getModelLabel(log.modelName)}</span>
    <span><b>کردار:</b> ${log.action}</span>
    <span><b>بەروار:</b> ${this.formatDate(log.createdAt)}</span>
    <span><b>لەلایەن:</b> ${log.performedBy ? log.performedBy.name : "نەزانراو"
            }</span>
  </div>
  <table>
    <thead><tr>
      <th>کۆن</th><th>نوێ</th><th>خانە</th>
    </tr></thead>
    <tbody>${rowsHtml}</tbody>
  </table>
  ${subTablesHtml}
  <script>window.onload=function(){window.print();}</script>
</body>
</html>`;

        printWindow.document.write(html);
        printWindow.document.close();
    };

    renderSubTableDiff = (key, oldArr, newArr) => {
        const oldItems = Array.isArray(oldArr) ? oldArr : [];
        const newItems = Array.isArray(newArr) ? newArr : [];
        const maxLen = Math.max(oldItems.length, newItems.length);
        if (maxLen === 0) return null;

        const allSubKeys = new Set();
        oldItems.forEach((item) =>
            Object.keys(item).forEach((k) => allSubKeys.add(k))
        );
        newItems.forEach((item) =>
            Object.keys(item).forEach((k) => allSubKeys.add(k))
        );
        const subKeys = [...allSubKeys].filter((k) => k !== "_id" && k !== "__v");

        const rows = [];
        for (let i = 0; i < maxLen; i++) {
            const oldItem = oldItems[i] || {};
            const newItem = newItems[i] || {};
            rows.push(
                <tr key={`sub-${key}-${i}`}>
                    <td
                        style={{
                            fontWeight: "bold",
                            textAlign: "center",
                            border: "1px solid #555",
                            backgroundColor: "#3c3c3c",
                            color: "#ffc107",
                        }}
                    >
                        {i + 1}
                    </td>
                    {subKeys.map((sk) => {
                        const ov =
                            oldItem[sk] !== undefined && oldItem[sk] !== null
                                ? String(oldItem[sk])
                                : "-";
                        const nv =
                            newItem[sk] !== undefined && newItem[sk] !== null
                                ? String(newItem[sk])
                                : "-";
                        const changed = ov !== nv;
                        return (
                            <td
                                key={sk}
                                style={{
                                    border: "1px solid #555",
                                    padding: "4px 8px",
                                    textAlign: "right",
                                    backgroundColor: changed ? "#fff3cd" : "transparent",
                                }}
                            >
                                {changed ? (
                                    <>
                                        <span
                                            style={{
                                                textDecoration: "line-through",
                                                color: "red",
                                                marginLeft: "8px",
                                            }}
                                        >
                                            {ov}
                                        </span>
                                        <span style={{ color: "green" }}>{nv}</span>
                                    </>
                                ) : (
                                    <span>{ov}</span>
                                )}
                            </td>
                        );
                    })}
                </tr>
            );
        }

        return (
            <div key={key} style={{ marginTop: "15px" }}>
                <h6
                    className="text-warning"
                    style={{ borderBottom: "1px solid #555", paddingBottom: "5px" }}
                >
                    {this.getLabel(key)}
                </h6>
                <div className="table-responsive">
                    <table
                        className="table table-sm table-bordered"
                        style={{ backgroundColor: "#2C3539" }}
                    >
                        <thead>
                            <tr style={{ backgroundColor: "#343a40" }}>
                                <th
                                    className="text-warning"
                                    style={{ border: "1px solid #555", textAlign: "center" }}
                                >
                                    #
                                </th>
                                {subKeys.map((sk) => (
                                    <th
                                        key={sk}
                                        className="text-warning"
                                        style={{
                                            border: "1px solid #555",
                                            textAlign: "right",
                                        }}
                                    >
                                        {this.getLabel(sk)}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>{rows}</tbody>
                    </table>
                </div>
            </div>
        );
    };

    render() {
        return (
            <ProductConsumer>
                {(value) => {
                    const { AL_modalOpen, AL_selectedLog, AL_CloseModal } = value;

                    if (!AL_modalOpen || !AL_selectedLog) return null;

                    const log = AL_selectedLog;
                    const oldData = log.oldData || {};
                    const newData = log.newData || {};

                    const allKeys = [
                        ...new Set([...Object.keys(oldData), ...Object.keys(newData)]),
                    ].filter((k) => !SUB_TABLE_KEYS.includes(k));

                    return (
                        <ModalContainer>
                            <div className="container-fluid">
                                <div className="row">
                                    <div
                                        id="modal"
                                        className="col-11 col-lg-10 mx-auto text-right p-4"
                                        style={{
                                            backgroundColor: "#2C3539",
                                            borderRadius: "8px",
                                            maxHeight: "85vh",
                                            overflowY: "auto",
                                            border: "2px solid #555",
                                        }}
                                    >
                                        {/* Header */}
                                        <div
                                            className="d-flex justify-content-between align-items-center mb-3"
                                            style={{
                                                borderBottom: "2px solid #ffc107",
                                                paddingBottom: "10px",
                                            }}
                                        >
                                            <div>
                                                <button
                                                    className="btn btn-sm btn-outline-warning mx-1"
                                                    onClick={() => this.handlePrint(log)}
                                                    title="چاپکردن"
                                                >
                                                    <i className="fas fa-print"></i>
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-outline-danger mx-1"
                                                    onClick={AL_CloseModal}
                                                >
                                                    <i className="fas fa-times"></i> داخستن
                                                </button>
                                            </div>
                                            <h5 className="text-warning m-0">
                                                <i className="fas fa-info-circle mx-1"></i>
                                                وردەکاری ژوورنال
                                            </h5>
                                        </div>

                                        {/* Info Row */}
                                        <div
                                            className="row mb-3 p-2"
                                            style={{
                                                backgroundColor: "#3c3c3c",
                                                borderRadius: "6px",
                                            }}
                                        >
                                            <div className="col-md-3 text-white text-right mb-1">
                                                <strong className="text-warning">بەش: </strong>
                                                {this.getModelLabel(log.modelName)}
                                            </div>
                                            <div className="col-md-3 text-white text-right mb-1">
                                                <strong className="text-warning">کردار: </strong>
                                                <span
                                                    className={`badge ${log.action === "DELETE"
                                                            ? "badge-danger"
                                                            : "badge-warning"
                                                        }`}
                                                >
                                                    {log.action}
                                                </span>
                                            </div>
                                            <div className="col-md-3 text-white text-right mb-1">
                                                <strong className="text-warning">لەلایەن: </strong>
                                                {log.performedBy ? log.performedBy.name : "نەزانراو"}
                                            </div>
                                            <div className="col-md-3 text-white text-right mb-1">
                                                <strong className="text-warning">بەروار: </strong>
                                                {this.formatDate(log.createdAt)}
                                            </div>
                                        </div>

                                        {/* Main Diff Table */}
                                        <div className="table-responsive">
                                            <table
                                                className="table table-sm table-bordered"
                                                style={{ backgroundColor: "#2C3539" }}
                                            >
                                                <thead>
                                                    <tr style={{ backgroundColor: "#343a40" }}>
                                                        <th
                                                            className="text-warning"
                                                            style={{
                                                                border: "1px solid #555",
                                                                textAlign: "right",
                                                            }}
                                                        >
                                                            کۆن
                                                        </th>
                                                        <th
                                                            className="text-warning"
                                                            style={{
                                                                border: "1px solid #555",
                                                                textAlign: "right",
                                                            }}
                                                        >
                                                            نوێ
                                                        </th>
                                                        <th
                                                            className="text-warning"
                                                            style={{
                                                                border: "1px solid #555",
                                                                textAlign: "right",
                                                            }}
                                                        >
                                                            خانە
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {allKeys.map((key) => {
                                                        const oldVal =
                                                            oldData[key] !== undefined &&
                                                                oldData[key] !== null
                                                                ? typeof oldData[key] === "object"
                                                                    ? JSON.stringify(oldData[key])
                                                                    : String(oldData[key])
                                                                : "-";
                                                        const newVal =
                                                            newData[key] !== undefined &&
                                                                newData[key] !== null
                                                                ? typeof newData[key] === "object"
                                                                    ? JSON.stringify(newData[key])
                                                                    : String(newData[key])
                                                                : "-";
                                                        const changed = oldVal !== newVal;

                                                        return (
                                                            <tr key={key}>
                                                                <td
                                                                    style={{
                                                                        border: "1px solid #555",
                                                                        padding: "6px 10px",
                                                                        textAlign: "right",
                                                                        backgroundColor: changed
                                                                            ? "#fff3cd"
                                                                            : "transparent",
                                                                        color: changed ? "red" : "#ddd",
                                                                        textDecoration: changed
                                                                            ? "line-through"
                                                                            : "none",
                                                                    }}
                                                                >
                                                                    {oldVal}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        border: "1px solid #555",
                                                                        padding: "6px 10px",
                                                                        textAlign: "right",
                                                                        backgroundColor: changed
                                                                            ? "#d4edda"
                                                                            : "transparent",
                                                                        color: changed ? "green" : "#ddd",
                                                                    }}
                                                                >
                                                                    {newVal}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        border: "1px solid #555",
                                                                        padding: "6px 10px",
                                                                        textAlign: "right",
                                                                        fontWeight: "bold",
                                                                        color: "#ffc107",
                                                                        backgroundColor: "#3c3c3c",
                                                                    }}
                                                                >
                                                                    {this.getLabel(key)}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Sub-table Diffs */}
                                        {SUB_TABLE_KEYS.map((stk) => {
                                            if (!oldData[stk] && !newData[stk]) return null;
                                            return this.renderSubTableDiff(
                                                stk,
                                                oldData[stk],
                                                newData[stk]
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </ModalContainer>
                    );
                }}
            </ProductConsumer>
        );
    }
}

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  #modal {
    background: #2c3539;
  }
`;

export default ModelAuditLog;
